module.exports = __webpack_public_path__ + "img/DPWmMfikTc1634106711716.16f513be.jpg";